import * as ngCore from '@angular/core'
import * as ngRouter from '@angular/router'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../state'
import { Store } from '../../store'

@ngCore.Component({
  imports: [
    ngRouter.RouterLink,
    ds.overlay.attached.Component,
    ds.layout.divider.Component,
  ],
  selector: 'atn-navbar-logo-menu',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /** @see {@link state.me.Feature} */
  public readonly meFeature = ngCore.inject(state.me.Feature)

  /**
   * Used to determine placement of this {@link Component}
   */
  public originSg = ngCore.input.required<HTMLElement>({ alias: 'origin' })
}
